import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class Id {
  private constructor() {}

  public static readonly prefix = 'UI.scripts.dealer-franchisee.dashboard.widget.BranchMonthlyDeliveryPipeline.';
  public static readonly purchaseOrderNo = `${Id.prefix}purchaseOrderNo`;
  public static readonly purchaseOrderTitle = `${Id.prefix}purchaseOrderTitle`;
  public static readonly mfgRef = `${Id.prefix}mfgRef`;
  public static readonly mfgStatus = `${Id.prefix}mfgStatus`;
  public static readonly proposedDelivery = `${Id.prefix}proposedDelivery`;
  public static readonly mfgDelivery = `${Id.prefix}mfgDelivery`;
  public static readonly branchName = `${Id.prefix}branchName`;
  public static readonly author = `${Id.prefix}author`;
  public static readonly issuedDate = `${Id.prefix}issuedDate`;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LangDashboardBranchMonthlyDeliveryPipeline {
  private constructor() {}

  public static purchaseOrderNo(): string {
    return interpolate(Id.purchaseOrderNo);
  }

  public static purchaseOrderTitle(): string {
    return interpolate(Id.purchaseOrderTitle);
  }

  public static mfgRef(): string {
    return interpolate(Id.mfgRef);
  }

  public static mfgStatus(): string {
    return interpolate(Id.mfgStatus);
  }

  public static proposedDelivery(): string {
    return interpolate(Id.proposedDelivery);
  }

  public static mfgDelivery(): string {
    return interpolate(Id.mfgDelivery);
  }

  public static branchName(): string {
    return interpolate(Id.branchName);
  }

  public static author(): string {
    return interpolate(Id.author);
  }

  public static issuedDate(): string {
    return interpolate(Id.issuedDate);
  }
}

export class DashboardBranchMonthlyDeliveryPipelineModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.purchaseOrderNo,
      "{{glossary 'purchase-order-abbrev'}} No.",
      'Column title for purchase order number'
    );
    register.add(
      Id.purchaseOrderTitle,
      "{{glossary 'purchase-order-abbrev'}} Title",
      'Column title for purchase order title'
    );
    register.add(Id.mfgRef, 'MFG Ref.', 'Column title for manufacturer reference');
    register.add(Id.mfgStatus, 'MFG Status', 'Column title for manufacturer status');
    register.add(Id.proposedDelivery, 'Proposed Delivery', 'Column title for proposed delivery date');
    register.add(Id.mfgDelivery, 'MFG Delivery', 'Column title for manufacturer delivery date');
    register.add(Id.branchName, 'Branch Name', 'Column title for branch name');
    register.add(Id.author, 'Author', 'Column title for author');
    register.add(Id.issuedDate, 'Issued Date', 'Column title for the date the purchase order was issued');
  }
}
